import axiosInstance from '../axios/axios.web.service';
import axios from 'axios';
import { dialogService } from '../dialog.service';
// import store from '@/store'
const baseDomain = process.env.VUE_APP_WEB_API_BASE_URL;
// const appMode = process.env.VUE_APP_MODE

const options = {
  headers: {
    'Content-Type': 'application/json',
  },
};

/**
 * Http GET
 */
export async function get(
  url,
  params = {},
  autoHandleError = () => true,
  exceptHandleErrorStatus = [],
  // eslint-disable-next-line no-unused-vars
  _user = false
) {
  const searchParams = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (Array.isArray(value)) {
      value.forEach((val) => {
        searchParams.append(key, val);
      });
    } else if (value !== null) {
      searchParams.append(key, value);
    }
  }
  const newOptions = {
    ...options,
    params: searchParams,
  };

  try {
    const requestURL = `${baseDomain}${url}`;
    const result = await axiosInstance.get(requestURL, newOptions);
    return result.data;
  } catch (error) {
    throw errorWrapper(error, autoHandleError, exceptHandleErrorStatus);
  }
}

/**
 * Http POST
 */
export async function post(
  url,
  params = {},
  autoHandleError = () => true,
  exceptHandleErrorStatus = []
) {
  const newOptions = {
    ...options,
  };

  try {
    const requestURL = `${baseDomain}${url}`;
    const result = await axiosInstance.post(requestURL, params, newOptions);

    return result.data;
  } catch (error) {
    throw errorWrapper(error, autoHandleError, exceptHandleErrorStatus);
  }
}

/**
 * Http POST with no authentication
 */
export async function postNoAuth(
  url,
  params = {},
  autoHandleError = () => true,
  exceptHandleErrorStatus = []
) {
  const newOptions = {
    ...options,
  };

  try {
    const requestURL = `${baseDomain}${url}`;
    const result = await axios.post(requestURL, params, newOptions);

    return result.data;
  } catch (error) {
    throw errorWrapper(error, autoHandleError, exceptHandleErrorStatus);
  }
}

/**
 * Http PUT
 */
export async function put(
  url,
  params = {},
  autoHandleError = () => true,
  exceptHandleErrorStatus = []
) {
  const newOptions = {
    ...options,
  };

  try {
    const requestURL = `${baseDomain}${url}`;
    const result = await axiosInstance.put(requestURL, params, newOptions);
    return result.data;
  } catch (error) {
    throw errorWrapper(error, autoHandleError, exceptHandleErrorStatus);
  }
}

/**
 * Http PUT with no authentication
 */
export async function putNoAuth(
  url,
  params = {},
  autoHandleError = () => true,
  exceptHandleErrorStatus = []
) {
  const newOptions = {
    ...options,
  };

  try {
    const requestURL = `${baseDomain}${url}`;
    const result = await axios.put(requestURL, params, newOptions);
    return result.data;
  } catch (error) {
    throw errorWrapper(error, autoHandleError, exceptHandleErrorStatus);
  }
}

/**
 * Http DELETE
 */
export async function del(
  url,
  params = {},
  autoHandleError = () => true,
  exceptHandleErrorStatus = []
) {
  const newOptions = {
    ...options,
    data: params,
  };

  try {
    const requestURL = `${baseDomain}${url}`;
    const result = await axiosInstance.delete(requestURL, newOptions);
    return result.data;
  } catch (error) {
    throw errorWrapper(error, autoHandleError, exceptHandleErrorStatus);
  }
}

/**
 * Http Post by token id
 */
export function errorWrapper(
  error,
  autoHandleError = () => true,
  // eslint-disable-next-line no-unused-vars
  _exceptHandleErrorStatus = []
) {
  console.log('errorWrapper ', error);
  let errorData = {
    code: 'HttpService/WrongSetting',
    message: 'Error happened!',
  };
  let status = error.response ? error.response.status : 'common';

  if (error.response) {
    console.log('error.response, ', error.response);
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    console.log({ response: error.response });
    console.log(error.response.data);
    console.log(status);
    console.log(error.response.headers);
    errorData = { ...error.response.data, status };
  } else if (error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    console.log(error.request);

    errorData.code = 'HttpService/postWithoutAuth/NoResponse';
    errorData.message = `
                The request was made but no response was received
                error.request is an instance of XMLHttpRequest in the browser and an instance of
                http.ClientRequest in node.js
                `;
  } else if (error.message === 'No internet connection') {
    status = 'NO_INTERNET';
    errorData.code = 'HttpService/NoInternet';
    errorData.message = error.message;
  } else {
    // Something happened in setting up the request that triggered an Error
    console.log('Error', error.message);
    if (String(error.message) === '401') {
      status = 401;
      errorData = { code: 'NotAuthorized', status };
    } else {
      errorData.code = 'HttpService/postWithoutAuth/WrongSetting';
      errorData.message = `
                  Something happened in setting up the request that triggered an Error
                  `;
    }
  }
  if (autoHandleError(errorData)) {
    dialogService.httpError({
      status,
      error: errorData,
      request: error.config,
      response: error.response,
    });
  }
  console.log(error.config);
  return errorData;
}
